import { render } from "./SimulatedUserAccount.vue?vue&type=template&id=7e158ea7&ts=true"
import script from "./SimulatedUserAccount.vue?vue&type=script&lang=ts"
export * from "./SimulatedUserAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__